import React from 'react';

export function RectangleIcon({ className }: { className: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="15"
			height="12"
			viewBox="0 0 15 12"
			fill="none"
			className={className}
		>
			<path d="M1.15131 0.879395H14.0006C14.5529 0.879395 15.0006 1.32711 15.0006 1.87939V10.9495C15.0006 11.7603 14.0863 12.234 13.4239 11.7664L0.574625 2.69636C-0.222487 2.1337 0.175613 0.879395 1.15131 0.879395Z" />
		</svg>
	);
}
